
import React, { createContext, useRef, useState, useContext } from "react";
import Perfect from "../Audio/Benjamín Amadeo, Soledad - Para Siempre (Official Video).mp3";

const AudioContext = createContext();

export function AudioProvider({ children }) {
  const audioRef = useRef(new Audio(Perfect)); // se mantiene entre rutas
  const [isPlaying, setIsPlaying] = useState(false);

  const play = () => {
    const audio = audioRef.current;
    if (audio) {
      const promise = audio.play();
      if (promise !== undefined) {
        promise
          .then(() => setIsPlaying(true))
          .catch((err) => console.warn("Autoplay error:", err));
      }
    }
  };

  const pause = () => {
    const audio = audioRef.current;
    if (audio) {
      audio.pause();
      setIsPlaying(false);
    }
  };

  return (
    <AudioContext.Provider value={{ audioRef, isPlaying, play, pause }}>
      {children}
    </AudioContext.Provider>
  );
}

export const useAudio = () => useContext(AudioContext);
